import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import { postDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import "./trainingform.css";
import { HiArrowSmallLeft } from "react-icons/hi2";
import PageHeader from "../../components/PageHeader/PageHeader";
import { PlusCircleFill } from "react-bootstrap-icons";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { useAppDispatch } from "../../store/storeRequests";
import { hideToast, showToast } from "../../store/Toast/toast.slice";

export interface Content {
  id: number;
  created: string;
  modified: string;
  is_delete: number;
  content_name: string;
  content_desc: string;
  training_id: number;
  content_type: string;
  link: string | null;
  reference_id: number;
  show_result: number;
  order: number;
  folderData: any;
  livepollData: any;
}
const ViewTrainingContent = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [content, setContent] = useState<Content[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedContent, setSelectedContent] = useState<Content | null>(null);
  const [isImageLoading, setIsImageLoading] = useState(true);
  const dispatch = useAppDispatch();
  const handleImageLoad = () => {
    // Hide loader when the image finishes loading
    setIsImageLoading(false);
    dispatch(showLoader("Loading"));
    setTimeout(()=>dispatch(hideLoader()),1000)
  };
  useEffect(() => {
    const fetchContent = async () => {
      try {
        const trainingId = Number(id);

        if (isNaN(trainingId)) {
          throw new Error("Invalid training_id");
        }

        dispatch(showLoader("Loading data..."));
        const response = await postDetails(APIList.GETALL_TRAININING_CONTENT, { training_id: trainingId });
        console.log("API Response:", response.data);

        if (Array.isArray(response.data)) {
          setContent(response.data);
        } else {
          setContent([response.data]);
        }
      } catch (err) {
        setError("Failed to fetch content data.");
        console.error("Error fetching content data:", err);
      } finally {
        setLoading(false);
        dispatch(hideLoader());
      }
    };

    fetchContent();
  }, [id]);

  const handleOpenModal = (item: Content) => {
    setSelectedContent(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedContent(null);
  };

const getMissingOrHighestOrder = (orders: number[]): number => {
  orders.sort((a, b) => a - b); 


  for (let i = 1; i <= orders.length; i++) {
    if (!orders.includes(i)) {
      return i; 
    }
  }


  return orders.length + 1;
};

  const handleDelete = async (item: Content) => {
    try {
      await postDetails(APIList.DELETE_CONTENT, { id: item.id });
      setContent(content.filter((c) => c.id !== item.id));
    } catch (err) {
      setError("Failed to delete content.");
      console.error("Error deleting content:", err);
    }
  };

  const handleContentClick = (item: Content) => {
    if (item.content_type === "Poll") {
      navigate(`/poll-data/${item.training_id}`);
    } else if (item.content_type === "Quiz") {
      navigate(`/quiz-data/${item.training_id}`);
    } else if (item.content_type === "Survey" && item.link) {
      window.open(item.link, "_blank");
    } else {
      handleOpenModal(item);
    }
  };

  if (error) return <div>{error}</div>;

  const renderButton = (item: Content) => {
    switch (item.content_type) {
      case "Video":
      case "Pdf":
      case "Image":
      case "Audio":
        return <Button className="btn btn-secondary" onClick={() => handleOpenModal(item)}>View Media</Button>;
      case "Survey":
        return <Button className="btn btn-secondary" onClick={() => handleContentClick(item)}>View Webview</Button>;
      case "Poll":
        return <Button className="btn btn-secondary" onClick={() => handleContentClick(item)}>View Poll</Button>;
      case "Quiz":
        return <Button className="btn btn-secondary" onClick={() => handleContentClick(item)}>View Quiz</Button>;
      case "Text":
        return <Button className="btn btn-secondary" onClick={() => handleOpenModal(item)}>View Text</Button>;
      default:
        return "N/A";
    }
  };

  const columns: TableColumn[] = [
    // { key: "id", label: "ID", sortable: true },
    {
      key: "content_name",
      label: "Content Name",
      dataType: "string",
      sortable: true,
      render: (item: Content) => renderButton(item),
    },
    { key: "content_type", label: "Content Type", sortable: true, dataType: "string" },
    { key: "order", label: "Order", sortable: true },
    // { key: "show_result", label: "Show Result", sortable: true, render: (item: Content) => item.show_result === 1 ? "Yes" : "No" },
    {
      key: "show_result",
      label: "Show Result",
      sortable: true,
      render: (item: Content) => {
        if (item.content_type === 'Image') {
          return "NA"; 
        }
        else  if (item.content_type === 'Video') {
          return "NA"; 
        }
        // else  if (item.content_type === 'Quiz') {
        //   return "No"; 
        // }
        else  if (item.content_type === 'Pdf') {
          return "NA"; 
        }
        else  if (item.content_type === 'Audio') {
          return "NA"; 
        }
        else  if (item.content_type === 'Text') {
          return "NA"; 
        }
        else  if (item.content_type === 'Survey') {
          return "NA"; 
        }
        else  if (item.content_type === 'Quiz') {
          return item.folderData.show_result === 1 ? "Yes" : "No";
        }
        return item.show_result === 1 ? "Yes" : "No"; 
      }
    },
    
    { key: "created", label: "Created On", sortable: true, render: (item: Content) => new Date(item.created).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }), },
  ];

  // const editItem = (item: Content) => {
  //   navigate(`/content-edit`, { state: { contentId: item.id, tranaingId: Number(id) } });
  // };

  const editItem = (item: Content) => {
    if (item.content_type === 'Quiz') {
      dispatch(showToast("Quiz is not Editable."));
      setTimeout(() => dispatch(hideToast()), 3000);
    } else {
      navigate(`/content-edit`, { state: { contentId: item.id, tranaingId: Number(id) } });
    }
  };
  

  const buttons = [
    {
      label: "Back to Training",
      theme: "warning",
      icon: <HiArrowSmallLeft />,
      onClick: () => navigate("/trainings"),
    },
    {
      label: "Add Content",
      theme: "warning",
      icon: <PlusCircleFill />,
      onClick: () => {

        const orders = content.map((item) => item.order);
        const nextOrder = getMissingOrHighestOrder(orders);

        navigate("/content-add", { state: { tranaingId: Number(id), order: nextOrder } });
      },
    },
  ];

  return (
    <LayoutContainer title={"Training"}>
      <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-list"></i>
          View Content
        </h2>
        <PageHeader buttons={buttons} />
      </div>

      <div>
        <CommonTable<Content>
          data={content}
          columns={columns}
          pagination={true}
          rowsPerPage={10}
          onDelete={handleDelete}
          onEdit={editItem}
          actions={{
            view: false,
            edit: true,
            delete: true,
            checkbox: false,
            status: false,
            showModal: false,
          }}
        />
      </div>

      {selectedContent && (
        <Modal show={showModal} onHide={handleCloseModal} size="lg">
         <Modal.Body>
  {selectedContent.content_type === "Video" && (
    <video controls width="100%">
      <source src={selectedContent.content_name} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  )}
  
  {selectedContent.content_type === "Pdf" && (
    <div className="h-100">
      <iframe src={selectedContent.content_name} className="w-100" style={{ height: "500px" }} />
    </div>
  )}

  {selectedContent.content_type === "Image" && (
    <img src={selectedContent.content_name} alt={selectedContent.content_desc} width="100%"
    onLoad={handleImageLoad} />
  )}

  {selectedContent.content_type === "Audio" && (
    <audio controls>
      <source src={selectedContent.content_name} type="audio/mpeg" />
      Your browser does not support the audio element.
    </audio>
  )}

{selectedContent.content_type === "Text" && (
  <div className="text-content">
    <p>{selectedContent.content_desc.replace(/<\/?[^>]+(>|$)/g, "")}</p>
  </div>
)}


</Modal.Body>

          <Modal.Footer>
            <Button variant="danger" onClick={handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </LayoutContainer>
  );
};

export default ViewTrainingContent;


